// import {
//   AUTH,
//   LOGOUT,
//   UPDATE_USER,
//   FETCH_USERS,
//   START_LOADING,
//   END_LOADING,
//   DELETE_USER,
// } from "../actions/constants";

// const authReducer = (
//   state = { authData: null, isLoading: true, users: [] },
//   action
// ) => {
//   switch (action.type) {
//     case AUTH:
//       localStorage.setItem("profile", JSON.stringify({ ...action?.data }));
//       // console.log(action?.data)
//       return { ...state, authData: action?.data };
//     case START_LOADING:
//       return { ...state, isLoading: true };
//     case END_LOADING:
//       return { ...state, isLoading: false };
//     case FETCH_USERS:
//       return {
//         ...state,
//         users: action.payload,
//       };
//     case LOGOUT:
//       localStorage.removeItem("profile");
//       return { ...state, authData: null };

//     // case UPDATE_USER:
//     //   return {
//     //     ...state,
//     //     users: state.users.map((user) =>
//     //       user._id === action.payload._id ? action.payload : user
//     //     ),
//     //   };

//     case "UPDATE_USER": // Should be "UPDATE" if standard
//       return {
//         ...state,
//         users: state.users.map((u) =>
//           u._id === action.payload._id ? action.payload : u
//         ),
//       };

//     // case UPDATE_USER:
//     //   // return {...state, users: state.users.map((user) => (user._id === action.payload._id ? action.payload : user))}
//     //   // localStorage.setItem("profile", JSON.stringify({ ...action?.data }));
//     //   //  console.log(action?.data)
//     //   return { users: state.users.map((user) => (user._id === action.payload._id ? action.payload : user))};
//     case DELETE_USER:
//       return {
//         ...state,
//         users: state.users.filter((user) => user._id !== action.payload),
//       };

//     default:
//       return state;
//   }
// };

// export default authReducer;

//----------------------------------------------------------------

import {
  AUTH,
  LOGOUT,
  UPDATE_USER,
  FETCH_USERS,
  START_LOADING,
  END_LOADING,
  DELETE_USER,
  FETCH_USER_TYPES,
  CREATE_USER_TYPE,
  UPDATE_USER_TYPE,
  DELETE_USER_TYPE,
} from "../actions/constants";

const authReducer = (
  state = { authData: null, isLoading: true, users: [], userTypes: [] },
  action
) => {
  switch (action.type) {
    case AUTH:
      localStorage.setItem("profile", JSON.stringify({ ...action?.data }));
      return { ...state, authData: action?.data };
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_USERS:
      return { ...state, users: action.payload };
    case LOGOUT:
      localStorage.clear();
      return { ...state, authData: null };
    case UPDATE_USER:
      return {
        ...state,
        users: state.users.map((u) => (u._id === action.payload._id ? action.payload : u)),
      };
    case DELETE_USER:
      return {
        ...state,
        users: state.users.filter((user) => user._id !== action.payload),
      };
    case FETCH_USER_TYPES:
      return { ...state, userTypes: action.payload || [] }; // Fallback to empty array if payload is undefined
    case CREATE_USER_TYPE:
      return { ...state, userTypes: [...state.userTypes, action.payload] };
    case UPDATE_USER_TYPE:
      return {
        ...state,
        userTypes: state.userTypes.map((ut) => ut.name === action.payload.name ? action.payload : ut),
      };
    case DELETE_USER_TYPE:
      return {
        ...state,
        userTypes: state.userTypes.filter((ut) => ut.name !== action.payload),
      };

      
    default:
      return state;
  }
};

export default authReducer;